import { render, staticRenderFns } from "./depositosBysede.vue?vue&type=template&id=08a4eaff&scoped=true"
import script from "./depositosBysede.vue?vue&type=script&lang=js"
export * from "./depositosBysede.vue?vue&type=script&lang=js"
import style0 from "./depositosBysede.vue?vue&type=style&index=0&id=08a4eaff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a4eaff",
  null
  
)

export default component.exports